/**
 * 区分 tradePartnerType（customers.trade_partner_type）
 * 出典：要件書 5.2
 */
export const TRADE_PARTNER_TYPE_VALUES = ['sales', 'supplier'] as const;

export type TradePartnerType = (typeof TRADE_PARTNER_TYPE_VALUES)[number];

export const TRADE_PARTNER_TYPE_LABELS: Readonly<Record<TradePartnerType, string>> = {
  sales: '販売先',
  supplier: '仕入先',
};
